import getProp from '@f/get-prop'

export const getIntegrationSettingsRequest = (state, workspaceSlug, projectSlug, integrationName) =>
  getProp(`integrationSettings.${workspaceSlug}-${projectSlug}-${integrationName}`, state) || {}

export const getIntegrationSettings = (state, workspaceSlug, projectSlug, integrationName) =>
  getIntegrationSettingsRequest(state, workspaceSlug, projectSlug, integrationName).data || {}



// WEBPACK FOOTER //
// ./selectors/integration-settings.js